import { specialSalesCategories } from "api-types/builders/salesCategory";
import { SalesCategory } from "common/types/salesCategoryTypesEnum";
import { Message } from "ui/text/Message";

export const extraOptionMsg =
  "These options don't affect the floor plan in Showroom and will therefore be displayed in the Extra Options view only.";

export const salesCategoryMessages: { [key in SalesCategory]?: string } = {
  UNCATEGORIZED:
    "These Options have no Sales Category and will therefore appear in the Misc - General category in Showroom.",
  OPERATIONS: "Options in the Operations category don't appear in Showroom.",
  EXTRA_OPTIONS: "These Options will appear in the Extra Options category in Showroom.",
  DESIGN_PALETTES: "Palettes are a combination of materials and colors that affect the exterior of a home.",
};

export const messageRelatedSalesCategories = [...specialSalesCategories, SalesCategory.DESIGN_PALETTES];

export function OptionSetSalesCategoryMessage({ salesCategory }: { salesCategory: string }) {
  if (!messageRelatedSalesCategories.includes(salesCategory as SalesCategory)) {
    return null;
  }

  return <Message messageType="info">{salesCategoryMessages[salesCategory]}</Message>;
}
